import React, { Suspense, lazy } from 'react';
import '@submodules/fe-core-ui/src/style/theme.css';
import '@submodules/fe-core-ui/src/style/tailwind.css';
import '@src/styles/index.css';
import '@src/styles/theme.css';

import ReactDOM from 'react-dom/client';
import { domAnimation, LazyMotion } from 'framer-motion';

/*!
 * Learnifier fe-core-header
 */

const Header = lazy(() => import('./Header'));

ReactDOM.createRoot(
  document.getElementById('fe-core-header-root') as HTMLElement,
).render(
  <React.StrictMode>
    <Suspense>
      <LazyMotion features={domAnimation}>
        <Header />
      </LazyMotion>
    </Suspense>
  </React.StrictMode>,
);

/*
 * Demo app
 */
if (import.meta.env.MODE === 'development') {
  import('./demo/DemoAppRouter').then(({ DemoAppRouter }) => {
    const root = document.getElementById('demo-app-root') as HTMLElement;
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <Suspense fallback={<div>Loading...</div>}>
          <DemoAppRouter />
        </Suspense>
      </React.StrictMode>,
    );
  });
}
